import React from "react";
import {
  CloseOutlined,
  FileTextOutlined,
  RocketOutlined,
  StarFilled,
  ThunderboltOutlined,
} from "@ant-design/icons";
import { getFeatureNewsDesign, getFeatureNewsKicker } from "./featureNewsDesigns";
import { sanitizeNewsHtml, splitNewsLeadAndBody } from "./sanitizeNewsHtml";
import FeatureNewsIllustration from "./FeatureNewsIllustration";

const BADGE_ICONS = {
  aurora: StarFilled,
  editorial: FileTextOutlined,
  midnight: RocketOutlined,
  pulse: ThunderboltOutlined,
};

const FeatureNewsCard = ({ item, onClose }) => {
  const design = getFeatureNewsDesign(item?.designId);
  const kicker = getFeatureNewsKicker(item);
  const html = sanitizeNewsHtml(item?.pageHtml || item?.bodyHtml || item?.body || "");
  const { leadHtml, bodyHtml } = splitNewsLeadAndBody(html);
  const BadgeIcon = BADGE_ICONS[design.id] || StarFilled;

  return (
    <article className={`feature-news-card feature-news-card--${design.id}`}>
      <header className="feature-news-hero">
        {onClose ? (
          <button
            type="button"
            className="feature-news-card-close"
            aria-label="Dismiss"
            onClick={onClose}
          >
            <CloseOutlined />
          </button>
        ) : null}
        <div className="feature-news-hero-copy">
          <span className="feature-news-badge">
            <BadgeIcon />
            {kicker}
          </span>
          <h2 className="feature-news-hero-title">{item?.title}</h2>
          {leadHtml ? (
            <div
              className="feature-news-hero-text"
              dangerouslySetInnerHTML={{ __html: leadHtml }}
            />
          ) : null}
        </div>
        <FeatureNewsIllustration variant={design.id} />
      </header>
      {bodyHtml ? (
        <div className="feature-news-panel">
          <div
            className="feature-news-card-body"
            dangerouslySetInnerHTML={{ __html: bodyHtml }}
          />
        </div>
      ) : null}
    </article>
  );
};

export default FeatureNewsCard;
